import { CustomErrorInterface } from "./Common";
import { MixtureChooseEnum } from "./Mixture";

export enum MEASURE_UNIT {
  HundredGrams = "100g",
  OneKilogram = "1kg",
}

export interface CondimentForCalculationInterface {
  id: number;
  percentage?: number;
  price: number;
  grams?: number;
  medDensity: number;
  parts?: number;
  minWeight: number;
}

export interface CalculationPriceInterface {
  discountValue: number;
  priceWithoutVatPerCup: number;
  priceWithoutVatWithMarkup: number;
  priceWithVatPerCup: number;
  priceWithVatAndDiscount: number;
  priceForOneHundredGrams: number;
  priceForOneKilogram: number;
  totalPrice: number;
  totalValueWithAllProperties: number;
  totalPriceWithoutVat: number;
  totalValuePerNumberOfJars: number;
  totalValueWithoutVatPerNumberOfJars: number;
}

export interface CalculationVolumeInterface {
  minVolumeOfMix: number;
  maxVolumeOfMix: number;
}

export interface CalculationRequestInterface {
  condiments: CondimentForCalculationInterface[];
  selectedWeight: number;
  numberOfJars: number;
  webshopId: number;
  mixtureOption: MixtureChooseEnum;
}

export interface CalculationResponseInterface {
  prices: CalculationPriceInterface;
  volume: CalculationVolumeInterface;
  currencyShortName: string;
  countryMeasureUnit: MEASURE_UNIT;
}

export interface CalculationState {
  isLoading: boolean;
  error: CustomErrorInterface | undefined;
  prices: CalculationPriceInterface;
  volume: CalculationVolumeInterface;
  currencyShortName: string;
  countryMeasureUnit: MEASURE_UNIT;
  calculationRequestCount: number;
}
